import { render, staticRenderFns } from "./ProfilesComponent.vue?vue&type=template&id=33757e2b&scoped=true"
import script from "./ProfilesComponent.vue?vue&type=script&lang=js"
export * from "./ProfilesComponent.vue?vue&type=script&lang=js"
import style0 from "./ProfilesComponent.vue?vue&type=style&index=0&id=33757e2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33757e2b",
  null
  
)

export default component.exports